<template>
    <section class="panel">
            <header class="panel-heading">
                <h2 class="panel-title">Subscripciones</h2>
            </header>
            <div class="panel-body" v-if="isLoading">
                <img src="/assets/images/loading.gif" alt="loading..." />
            </div>
            <div class="panel-body" v-if="!isLoading">
                <div v-for="subscription in subscriptions" :key="subscription.id" >
                    <h3>Servicio: {{ subscription.shortDescription }} 
                        <span class="badge"> {{formatStatus(subscription.status)}}</span></h3>
                    <p class="lead mt-xs"><b>Fecha:</b> {{ formatDate(subscription.startDate) }} -  
                                                        {{ formatDate(subscription.endDate) }}</p>
                    <div v-if="subscription.downloadContractUrl!=''">
                        <a class="mb-xs mt-xs mr-xs btn btn-primary" @click="downloadFilePdfLink(subscription.downloadContractUrl)">
                            <i class="fa fa-download"></i> Descargar PDF
                        </a>
                    </div>                    
                    <hr />
                </div>
            </div>
     </section>        
</template>

<script>
    export default {
        name: 'Subscriptions',
        data: function () {
            return {
                isLoading : true,
                subscriptions: {}
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                this.refresh();
            });
        },
        computed: {
            accountId () {
                return this.$store.state.accountId
            }
        },
        methods: {
            formatDate: function (dateString) {
                var date = new Date(dateString);
                // https://www.npmjs.com/package/dateformat
                var dateFormat = require('dateformat');
                return dateFormat(date, "mmmm dS, yyyy");
            },
            formatStatus: function (subscriptionStatus) {
                var status = new String;
                switch (subscriptionStatus) {
                    case "Active": status= "Activo"; break; 
                    case "Active - Pending Contract": status= "Activo con Contrato Pendiente"; break; 
                    case "Completed": status= "Completado"; break; 
                    case "Cancelled": status= "Cancelado"; break; 
                    default: status= subscriptionStatus; break; 
                    }
                return status;
            },
            async downloadFilePdfLink(filePath) {
                var link = filePath;
                window.open(link, '_blank');
            },
            async refresh () {
                var self = this;
                this.isLoading = true;
                const jwtAccessToken = await this.$auth.getTokenSilently();
                const jwtIdToken = (await this.$auth.getIdTokenClaims()).__raw;

                this.axios.get(process.env.VUE_APP_API_PATH + "subscriptions/list",
                                        {
                            headers: {
                                Authorization: `Bearer ${jwtAccessToken}`,  // send the access token through the 'Authorization' header,
                                IdToken: `${jwtIdToken}`
                            }
                        }
                    ).
                    then(function (response) {
                        //console.debug(response.data);
                        self.subscriptions = response.data;
                        self.isLoading = false;
                    }, function (error) {
                        self.isLoading = false;
                    });
            }
        }
    }
</script>